import { Button } from '@/components/ui/button';
import { PDKEmptyValueIcon } from '@/components/ui/pdk-icons';
import { cn } from '@/lib/utils';
import type { DeliveryStage } from '@/models/types';
import { DELIVERY_STAGE_OPTIONS } from './delivery-stage-options';

export const DeliveryStageBadge = ({
  value,
  hideCopy = false,
  buttonRef,
  buttonVariant = 'ghost',
  className,
}: {
  value: DeliveryStage | null | undefined;
  hideCopy?: boolean;
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  className?: string;
  buttonVariant?: 'outline' | 'ghost';
}) => {
  return (
    <Button
      variant={buttonVariant}
      className={cn('p-1 h-fit', className)}
      ref={buttonRef}
    >
      {value === null && (
        <>
          <PDKEmptyValueIcon className="h-3.5 w-3.5" />
          <p className="rounded text-xs text-gray-600">No Delivery Stage</p>
        </>
      )}
      {DELIVERY_STAGE_OPTIONS.map((option) => {
        if (option.value === value) {
          return <div key={option.value}>{option.icon}</div>;
        }
        return null;
      })}

      {!hideCopy && (
        <p className="rounded text-xs  text-gray-600 flex flex-row gap-1">
          {
            DELIVERY_STAGE_OPTIONS.find((option) => option.value === value)
              ?.label
          }
        </p>
      )}
    </Button>
  );
};
